import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function formatZAR(value) {
    if (value == null || isNaN(value)) return "—";
    const sign = value < 0 ? "-" : "";
    return (
        sign +
        "R " +
        Math.abs(Number(value))
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );
}

export function formatInt(value) {
    if (value == null || isNaN(value)) return "—";
    return Math.round(Number(value)).toLocaleString("en-ZA");
}

export function formatPct(value) {
    if (value == null || isNaN(value)) return "—";
    const v = Number(value);
    const sign = v > 0 ? "+" : "";
    return `${sign}${v.toFixed(1)}%`;
}
